import { api } from "assets/scripts/utilities/api-clients";

export const index = async (options = {}) => {
  const response = await api.get("/kam/document/master/subcategories", options);

  return response;
};

export const get = async (options = {}) => {
  const response = await api.get("/kam/document/master", options);

  return response;
};
